import { render, staticRenderFns } from "./tab-row-inner-tabs.vue?vue&type=template&id=521ef9f4&scoped=true&"
import script from "./tab-row-inner-tabs.vue?vue&type=script&lang=js&"
export * from "./tab-row-inner-tabs.vue?vue&type=script&lang=js&"
import style0 from "./tab-row-inner-tabs.vue?vue&type=style&index=0&id=521ef9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ef9f4",
  null
  
)

export default component.exports